import React, { FC } from "react"

const RadioUncheckedIcon: FC = () => {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
      <path
        d="M23.5 14C23.5 19.2467 19.2467 23.5 14 23.5C8.75329 23.5 4.5 19.2467 4.5 14C4.5 8.75329 8.75329 4.5 14 4.5C19.2467 4.5 23.5 8.75329 23.5 14Z"
        fill="white"
        stroke="#2F3B5A"
      />
    </svg>
  )
}

export default RadioUncheckedIcon
